<template>
    <div class="">
        <loader/>
      <div class="">
          <br>
        <h1 class="titlequestion">{{$t('step5.st1')}}</h1>
        <br>
      </div>
      <hr>
      <!-- reparar con b-col  -->
        <div class="container-fluid">
           
            <b-row>
                <b-col offset-lg="1" lg="4">
                        <!-- primer car columna izquierda-->
                        <div class="card">
                            <div class="card-body">

                                <h2 class="titledetails">{{$t('step5.st2')}}</h2>

                                <b-row>
                                    <b-col lg="12">
                                        <h3>{{$t('step5.st3')}}</h3>
                                        <span>{{fecha_retiro}}, {{hora_retiro}}</span><br>
                                        <span>{{fecha_devolucion}}, {{hora_devolucion}}</span>
                                    </b-col>
                                    
                                </b-row>
                                <br>
                                <b-row>
                                    <b-col lg="12">
                                        <h3>{{$t('step5.st4')}}</h3>
                                        <span>{{sucursal_salida.nombre_web}}</span><br>
                                        <span>{{sucursal_entrega.nombre_web}}</span>
                                    </b-col>
                                    
                                </b-row>

                            </div>
                        </div>
                        <!-- primer car columna izquierda-->
                        <br>
                        <!-- segundo card columna izquierda-->
                        <div class="card">
                            <div class="card-body">

                                <h2 class="titledetails">{{$t('step5.st2')}}</h2>

                                <b-row>
                                    <b-col lg="6">
                                        <!-- <h2 class="titledetails">{{auto.categoria.categoria}}</h2> -->
                                        <div v-if="$i18n.locale==='en'">
                                          <h2 v-if="auto.categoria.categoria==='Economicos'" class="titledetails">Economic</h2>
                                          <h2 v-else-if="auto.categoria.categoria==='Sedan'" class="titledetails">Intermediate</h2>
                                          <h2 v-else-if="auto.categoria.categoria==='Premium'" class="titledetails">Premium</h2>
                                          <h2 v-else-if="auto.categoria.categoria==='Lujo'" class="titledetails">Luxury</h2>
                                          <h2 v-else-if="auto.categoria.categoria==='Grande'" class="titledetails">Fullsize</h2>
                                          <h2 v-else class="titledetails">{{auto.categoria.categoria}}</h2>
                                        </div>
                                        
                                        <span>{{auto.marca}} {{auto.modelo}}</span><br>
                                        <span><i class="icon-transmission ic"></i> {{auto.transmision}}</span>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-img :src="auto.image.url_imagen" class="/img-categoria" fluid alt="national car rental"></b-img>
                                    </b-col>
                                </b-row>
                                <br>
                                <b-row>
                                    <b-col>
                                        <span>{{$t('step5.st6')}}</span>
                                    </b-col>
                                    <b-col>
                                         <span style="float:right;">US$ {{parseFloat(calculo.detalle.tarifa).toFixed(2)}}</span>
                                    </b-col>
                                </b-row>
                                <br>
                                <b-row>
                                    
                                </b-row>
                                <br>
                                    <b-row>
                                    <b-col>
                                        <h3>{{$t('step5.st7')}}</h3>
                                    </b-col>
                                    <b-col>
                                        <div class="modificar"><router-link class="btnModificar" :to="{ name: 'Reservestep4'}">{{$t('step5.st8')}}</router-link></div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <span v-for="item in data.coberturas" :key="item.sigla">
                                            {{item.nombre}} <span class="float-right">US$ {{item.monto}}</span><br>
                                        </span>
                                        <span v-for="item in data.accesorios" :key="item.sigla">
                                            {{item.nombre}} <span class="float-right">US$ {{item.monto}}</span><br>
                                        </span>
                                        <span v-show="data.conductor_adicional > 0">
                                            {{$t('step5.st9')}}({{data.conductor_adicional}}) 
                                            <span class="float-right">US$ {{parseFloat(calculo.detalle.conductor_adicional * data.conductor_adicional).toFixed(2)}}
                                            </span>
                                            <br>
                                        </span>
                                    </b-col>
                                </b-row>
                                <br>
                                <b-row>
                                    <b-col>
                                        <h3>{{$t('step5.st10')}}</h3>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <span>{{$t('step5.st11')}}</span><br>
                                        <span>Subtotal</span><br>
                                        <span>{{$t('step5.st13')}}</span>
                                    </b-col>
                                    <b-col >
                                        <span class="float-right">US$ {{ calculo.detalle.apo_fee }}</span><br>
                                        <span class="float-right">US$ {{ calculo.detalle.subtotal }}</span><br>
                                        <span class="float-right">US$ {{ calculo.detalle.itbm }}</span>
                                    </b-col>
                                </b-row>
                                <br>
                                <b-row>
                                    <b-col sm="12">
                                        <h3>{{$t('step5.st14')}}</h3>
                                        <span style="float:right;font-size:30px;"><strong>US$ {{calculo.detalle.total}}</strong></span>
                                    </b-col>
                                    <!-- <b-col sm="10">
                                        <span style="float:right;font-size:30px;"><strong>US$ {{parseFloat(data.tarifa).toFixed(2)}}</strong></span>
                                    </b-col> -->
                                </b-row>
                            </div>
                        </div>
                        <!-- segundo card columna izquierda-->
                        <br>
                        <!-- segundo card columna izquierda-->
                        <div class="card">
                            <div class="card-body">

                                <h2 class="titledetails">{{$t('step5.st15')}}</h2>

                                <b-row>
                                    <b-col>
                                        <ul>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st16')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st17')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st18')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st19')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st20')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st20_1')}}</a></li>
                                            <li><a data-toggle="modal" data-target="#policiesModal" class="btnModificar">{{$t('step5.st20_2')}}</a></li>
                                        </ul>
                                    </b-col>
                                </b-row>
                                <!-- modal for policies -->
                                <div 
                                class="modal fade" 
                                id="policiesModal" 
                                tabindex="-1" 
                                aria-labelledby="policies-modal" 
                                aria-hidden="true">
                                  <div class="modal-dialog modal-xl">
                                    <div class="modal-content rounded-0">
                                      <div 
                                      class="modal-header rounded-0" 
                                      style="background-color:#169a5a;">
                                        <h5 class="modal-title modaltitle" id="policies-modal">{{$t('modalpolicy.pol1')}}</h5>
                                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                          <span aria-hidden="true">&times;</span>
                                        </button>
                                      </div>
                                      <div class="modal-body">
                                        <b-row>
                                          <b-col md="5">
                                              <div style="margin-top:-17px"  class="nav flex-column " id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                                <a class="btnpolicies nav-link active" id="v-pills-1-tab" data-toggle="pill" href="#v-pills-1" role="tab" aria-controls="v-pills-1" aria-selected="true">
                                                  <p class="ml-3">{{$t('modalpolicy.pol2')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-2-tab" data-toggle="pill" href="#v-pills-2" role="tab" aria-controls="v-pills-2" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol3')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-3-tab" data-toggle="pill" href="#v-pills-3" role="tab" aria-controls="v-pills-3" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol5')}} 
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-4-tab" data-toggle="pill" href="#v-pills-4" role="tab" aria-controls="v-pills-4" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol7')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-5-tab" data-toggle="pill" href="#v-pills-5" role="tab" aria-controls="v-pills-5" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol9')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-6-tab" data-toggle="pill" href="#v-pills-6" role="tab" aria-controls="v-pills-6" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol11')}}
                                                  </p>
                                                </a>
                                                <a class="btnpolicies nav-link" id="v-pills-7-tab" data-toggle="pill" href="#v-pills-7" role="tab" aria-controls="v-pills-7" aria-selected="false">
                                                  <p class="ml-3">{{$t('modalpolicy.pol13')}}
                                                  </p>
                                                </a>
                                              </div>
                                          </b-col>
                                          <b-col md>
                                            <div class="tab-content" id="v-pills-tabContent">
                                              <div class="tab-pane fade show active" id="v-pills-1" role="tabpanel" aria-labelledby="v-pills-1-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol2')}}</p>
                                                <renttermscomp/>
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-2" role="tabpanel" aria-labelledby="v-pills-2-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol3')}}</p>
                                               {{$t('modalpolicy.pol4')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-3" role="tabpanel" aria-labelledby="v-pills-3-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol5')}} </p>
                                                {{$t('modalpolicy.pol6')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-4" role="tabpanel" aria-labelledby="v-pills-4-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol7')}}</p>
                                                {{$t('modalpolicy.pol8')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-5" role="tabpanel" aria-labelledby="v-pills-5-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol9')}}</p>
                                                {{$t('modalpolicy.pol10')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-6" role="tabpanel" aria-labelledby="v-pills-6-tab">
                                                <p 
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol11')}}</p>
                                                {{$t('modalpolicy.pol12')}}
                                              </div>
                                              <div class="tab-pane fade" id="v-pills-7" role="tabpanel" aria-labelledby="v-pills-7-tab">
                                                <p
                                                class="titletermsmodal"
                                                style="border-bottom: solid 2px #000000 !important;"
                                                >{{$t('modalpolicy.pol13')}}</p>
                                                {{$t('modalpolicy.pol14')}}
                                              </div>
                                            </div>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <br>
                </b-col>
                <b-col lg="6" >
                    <form>
                        <!-- primer card del formulario-->
                    <div class="card2">
                        <div>
                            <span>{{$t('step5.st21')}}</span>
                        </div>
                        <div class="card-header">
                            <h2 v-if="!isAuth">{{$t('step5.st22')}}</h2>
                            <h2 v-else>Datos Adicionales</h2>
                        </div>
                        <div class="card-body">
                            <!--primera fila-->
                            <b-row>
                                <b-col lg="6">

                                    <!--pasaporte-->
                                    <b-form-group :label="$t('step5.lbl1')" label-for="pasaporte" description="">
                                        <b-form-input v-if="!isAuth" id="pasaporte" type="text" required placeholder="" v-model='data.idp'>
                                        </b-form-input>
                                        <b-form-input v-else id="pasaporte" type="text" required placeholder="" :value="user.cedula" disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--pasaporte-->
                                </b-col>

                                <b-col lg="6">
                                    <!--nombres-->
                                    <b-form-group :label="$t('step5.lbl2')" label-for="nombres" description="">
                                        <b-form-input   
                                                        v-if="!isAuth"
                                                        id="nombres" 
                                                        type="text" 
                                                        required 
                                                        placeholder="" 
                                                        v-model='data.nombres'>
                                        </b-form-input>
                                        <b-form-input   
                                                        v-else
                                                        id="nombres" 
                                                        type="text" 
                                                        required 
                                                        placeholder="" 
                                                        disabled
                                                        v-model='user.nombre'>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--nombres-->
                                </b-col>
                            </b-row>
                            <!--primera fila-->

                            <!--segunda fila-->
                            <b-row>
                                <b-col lg="6">

                                    <!--apellido paterno-->
                                    <b-form-group :label="$t('step5.lbl3')" label-for="a_paterno" description="">
                                        <b-form-input v-if="!isAuth" id="a_paterno" type="text" required placeholder="" v-model='data.apellido_paterno'>
                                        </b-form-input>

                                        <b-form-input v-else id="a_paterno" type="text" required placeholder="" v-model='user.apellido_paterno' disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--apellido paterno-->
                                </b-col>

                                <b-col lg="6">

                                    <!--apellido materno-->
                                    <b-form-group :label="$t('step5.lbl4')" label-for="a_materno" description="">
                                        <b-form-input v-if="!isAuth" id="a_materno" type="text" placeholder="" v-model='data.apellido_materno'>
                                        </b-form-input>
                                        <b-form-input v-else id="a_materno" type="text" placeholder="" v-model='user.apellido_materno' disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--apellido materno-->
                                </b-col>
                            </b-row>
                            <!--segunda fila-->

                            <!--tercera fila-->
                            <b-row>
                                <b-col lg="6">

                                    <!--email-->
                                    <b-form-group :label="$t('step5.lbl5')" label-for="email" description="">
                                        <b-form-input v-if="!isAuth" id="email" type="email" required placeholder="" v-model='data.email'>
                                        </b-form-input>
                                        <b-form-input v-else id="email" type="email" required placeholder="" v-model='user.email' disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--email-->
                                </b-col>

                                <b-col lg="6">

                                    <!--pais-->
                                    <b-form-group :label="$t('step5.lbl6')" label-for="pais" description="">

                                        <b-form-input v-if="!isAuth" id="pais" type="text" required placeholder="" v-model='data.pais'>
                                        </b-form-input>

                                        <b-form-input v-else id="pais" type="text" required placeholder="" v-model='user.pais' disabled>
                                        </b-form-input>

                                    </b-form-group>
                                    <!--pais-->
                                </b-col>
                            </b-row>
                            <!--tercera fila-->

                            <!--cuarta fila-->
                            <b-row>
                                    <b-col lg="3" v-show="!isAuth">

                                    <!--prefijo-->
                                    <b-form-group :label="$t('step5.lbl7')" label-for="prefijo" description="">
                                        <b-form-input id="prefijo" type="text" placeholder="" v-model='data.prefijo'>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--prefijo-->
                                </b-col>

                                <b-col :lg="isAuth ? 12 : 3">

                                    <!--telefono-->
                                    <b-form-group :label="$t('step5.lbl8')" label-for="telefono" description="">
                                        <b-form-input id="telefono" type="text" required placeholder="" v-model='user.telefono' v-if="isAuth">
                                        </b-form-input>
                                        <b-form-input id="telefono" type="text" required placeholder="" v-model='data.tel' v-else>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--telefono-->
                                </b-col>
                              

                                <b-col :lg="isAuth ? 12 : 6">

                                    <!--forma de pago-->
                                    <b-form-group :label="$t('step5.lbl9')" label-for="forma-pago" description="">
                                         <b-form-select v-model="data.forma_pago" class="mb-3" required>
                                            <!-- This slot appears above the options from 'options' prop -->
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>{{$t('step5.st23')}}</b-form-select-option>
                                            </template>

                                            <!-- These options will appear after the ones from 'options' prop -->
                                            <b-form-select-option 
                                                v-for="fp in forma_pago" 
                                                :key="fp.id" 
                                                :value="fp.id">{{fp.forma_pago}}</b-form-select-option>
                                            </b-form-select>
                                    </b-form-group>
                                    <!--forma de pago-->
                                </b-col>
                            </b-row>
                            <!--cuarta fila-->

                        </div>
                    </div>
                    <!-- primer card del formulario-->
                    <br>
                    <!-- segundo card del formulario-->
                    <div class="card2">
                        <div>
                            <span></span>
                        </div>
                        <div class="card-header">
                            <h2>{{$t('step5.st24')}}</h2>
                        </div>
                        <div class="card-body">

                            
                            <!--primera fila-->
                            <b-row v-show="!isAuth">
                                <b-col lg="6">

                                    <!--pasaporte-->
                                    <b-form-group :label="$t('step5.lbl10')" label-for="licencia" description="">
                                        <b-form-input id="licencia" type="text"  placeholder="" v-model='data.num_licencia'>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--pasaporte-->
                                </b-col>

                                <b-col lg="6">

                                    <!--nombres-->
                                    <b-form-group :label="$t('step5.lbl11')" label-for="cel" description="">
                                        <b-form-input id="cel" type="text"  placeholder="" v-model='data.celular'>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--nombres-->
                                </b-col>
                            </b-row>
                            <!--primera fila-->

                            <!--segunda fila-->
                            <b-row>
                                <b-col lg="12">

                                    <!--observaciones-->
                                    <b-form-group :label="$t('step5.lbl12')" label-for="observaciones" description="">
                                        <b-form-textarea
                                            v-model='data.observaciones'
                                            id="observaciones"
                                            placeholder=""
                                            rows="3"
                                            max-rows="6"
                                            ></b-form-textarea>
                                    </b-form-group>
                                    <!--observaciones-->
                                </b-col>
                            </b-row>
                            <!--segunda fila-->
                        </div>
                    </div>
                    <!-- segundo card del formulario-->
                    <br>
                    <!-- tercer card del formulario-->
                    <div class="card2" v-show="!isAuth">
                        <div>
                            <span></span>
                        </div>
                        <div class="card-header">
                            <h2>{{$t('step5.st25')}}</h2>
                        </div>
                        <div class="card-body">
                            <!--primera fila-->
                            <b-row>
                                <b-col lg="6">

                                    <!--pasaporte-->
                                    <b-form-group :label="$t('step5.lbl13')" label-for="linea" description="">
                                        <b-form-input id="linea" type="text" placeholder="" v-model='data.linea_aerea'>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--pasaporte-->
                                </b-col>

                                <b-col lg="6">

                                    <!--nombres-->
                                    <b-form-group :label="$t('step5.lbl14')" label-for="num" description="">
                                        <b-form-input id="num" type="text" placeholder="" v-model='data.num_vuelo'>
                                        </b-form-input>
                                    </b-form-group>
                                    <!--nombres-->
                                </b-col>
                            </b-row>
                            <!--primera fila-->
                        </div>
                    </div>
                    <!-- tercer card del formulario-->
                    <br>
                    <!-- cuarto card del formulario-->
                    <div class="card2">
                        <div>
                            <span></span>
                        </div>
                        <div class="card-header">
                            <h2>{{$t('step5.st26')}}</h2>
                        </div>
                        <div class="card-body">

                            
                            <!--primera fila-->
                            <b-row>
                                <b-col lg="6">
                                    <span>{{$t('step5.st27')}}</span>
                                </b-col>

                                <b-col lg="6">

                                    <sup class="valor float-right">US$ {{parseFloat(calculo.detalle.total).toFixed(2)}}</sup>
                                    
                                </b-col>
                            </b-row>
                            <!--primera fila-->
                        </div>
                    </div>
                    <!-- cuarto card del formulario-->
                    <br>
                    <terminoscontrato/>
                    <b-form-checkbox v-model="checked" name="check-button" switch style="display:inline">
                             <p style="display:inline">
                                 Acepto las 
                            </p> 
                            <a style="text-decoration:none; padding:0px; margin-bottom: 15px; color: #169A5A; vertical-align:0; font-weight: bold;" type="button" class="btn btn-link" data-toggle="modal" data-target="#politicas">
                                políticas de privacidad
                            </a>
                    </b-form-checkbox>
                    <politicas/>
                        <br>
                        <button  @click.prevent="cuartoPaso({isAuth: isAuth, coberturas_obligadorias: calculo.detalle.cob_obligatoria})" class="btnConfirm text-uppercase" :disabled="!checked" :class="!checked ? 'btnNoConfirm' : 'btnConfirm'" type="submit">{{$t('buttons_label.reserve_now')}}</button>
                        <!--<vue-recaptcha ref="recaptcha" sitekey="6LdmSUQkAAAAAJXQk2rJF3t_Zi3grhGP_qD53KWH" />-->
                        <!--<button class="g-recaptcha" data-sitekey="6LdmSUQkAAAAAJXQk2rJF3t_Zi3grhGP_qD53KWH" data-callback='onSubmit' data-action='submit'>Enviar</button>-->
                        <!--class="btnConfirm text-uppercase" :disabled="!checked" :class="!checked ? 'btnNoConfirm' : 'btnConfirm'"-->
                         <!-- <button @click.prevent="reservar(isAuth), review_gtm()" class="btnConfirm text-uppercase" :disabled="!checked" :class="!checked ? 'btnNoConfirm' : 'btnConfirm'" type="submit">{{$t('buttons_label.reserve_now')}}</button> -->
                         <!-- <button v-else @click.prevent="reservar(isAuth)" class="btnConfirm text-uppercase" :disabled="!checked" :class="!checked ? 'btnNoConfirm' : 'btnConfirm'" type="submit">{{$t('buttons_label.reserve_now')}}</button> -->
                    </form>
                </b-col>
            </b-row>
        </div>
      <!-- reparar con b-col -->
      
    </div>
</template>
<script src="https://unpkg.com/vue-recaptcha@^2/dist/vue-recaptcha.min.js"></script>
<script>
import loader         from '@/components/loader.vue'
import renttermscomp  from '@/components/renttermscomp.vue'
import politicas  from '@/components/ModalPoliticasPrivacidad.vue'
import terminoscontrato  from '@/components/terminos_contrato'
import {mapState, mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import { useGtm } from '@gtm-support/vue2-gtm';
//import { VueRecaptcha } from 'vue-recaptcha';
    export default {
        created () {
            if(this.procesoReserva == false)
            {
                this.$router.push({path:"/"})
            }
            
        },
        async mounted() {
            if (await this.data) 
            setTimeout(() => {
                {
                  this.review_gtm()
                }
            }, 2000);
        },
        data() {
            return {
                country: '',
                region: '',
                checked:false,
                covers: {
                    EDD: {
                        monto:"",
                        nombre:"",
                        sigla:"EDD",
                    },
                    CAP: {
                        monto:"",
                        nombre:"",
                        sigla:"CAP",
                    },
                    CLP: {
                        monto:"",
                        nombre:"",
                        sigla:"CLP",
                    },
                    RAP: {
                        monto:"",
                        nombre:"",
                        sigla:"RAP",
                    }
                },
                accesorios: {
                    sillabb: {
                        monto: "",
                        nombre: "",
                        sigla: "MW"

                    },
                    mifi: {
                        monto: "",
                        nombre: "",
                        sigla: "SB"
                    }
                }
            }
        },
        components: {
            loader,
            renttermscomp,
            politicas,
            terminoscontrato
        },
         watch: {
            'addEdd': function (val, oldval) {
              if (val==true) {
                  //console.log('addEdd', val, this.covers.EDD.monto)
                  this.covers.EDD.monto = this.data.coberturas[0].monto
                  this.covers.EDD.nombre = this.data.coberturas[0].nombre
              }  
            },
             'addCap': function (val, oldval) {
               if (val==true) {
                   //console.log('addCap', val)
                   this.covers.CAP.monto = this.data.coberturas[1].monto
                   this.covers.CAP.nombre = this.data.coberturas[1].nombre
               }  
             },
            'addClp': function (val, oldval) {
              if (val==true) {
                  //console.log('addClp', val)
                  this.covers.CLP.monto = this.data.coberturas[2].monto
                  this.covers.CLP.nombre = this.data.coberturas[2].nombre
              }  
            },
             'addRap': function (val, oldval) {
               if (val==true) {
                   //console.log('addRap', val)
                   this.covers.RAP.monto = this.data.coberturas[3].monto
                   this.covers.RAP.nombre = this.data.coberturas[3].nombre
               }  
             },
             'addMifi': function (val, oldval) {
               if (val==true) {
                   //console.log('addMifi', val)
                    this.accesorios.mifi.monto = this.data.accesorios[0].monto
                    this.accesorios.mifi.nombre = this.data.accesorios[0].nombre
               }  
             },
             'addSillabb': function (val, oldval) {
               if (val==true) {
                   //console.log('addSillabb', val)
                   this.accesorios.sillabb.monto = this.data.accesorios[1].monto
                   this.accesorios.sillabb.nombre = this.data.accesorios[1].nombre
               }  
             },
             'addCondAdic': function (val, oldval) {
               if (val==true) {
                   //console.log('addCondAdic', val)
               }  
             },
            /*  data:  function (val, oldval) {
                 console.log('data')
               if (val!=null) {
                   console.log('data')
               }  
            } */
            },
        computed: {
            ifUserEmpty()
            {
                return Boolean(this.user)
            },
            //...mapState('reserva', ['auto', 'calculo', 'montoExtras', 'sucursales', 'forma_pago', 'itbms', 'subTotal', 'apo_fee']),
            ...mapState('autenticacion', ['user']),
            ...mapState('reservav2', ['data', 'calculo', 'sucursales', 'auto', 'forma_pago']),
            ...mapGetters('autenticacion', ['isAuth']),
            fecha_retiro()
                {
                    return moment(this.data.fecha_retiro).format('D MMMM YYYY')
                },
                fecha_devolucion()
                {
                    return moment(this.data.fecha_devolucion).format('D MMMM YYYY')
                },
                hora_retiro()
                {
                    return moment(this.data.hora_retiro, "h:mm A").format('LT')
                },
                hora_devolucion()
                {
                    return moment(this.data.hora_devolucion, "h:mm A").format('LT')
                },
                sucursal_salida()
                {
                    return this.sucursales.find(sucursal => sucursal.id == this.data.sucursal_retiro)
                },
                sucursal_entrega()
                {
                    return this.sucursales.find(sucursal => sucursal.id == this.data.sucursal_devolucion)
                }
        },
        methods: {
            ...mapActions('reservav2', ['cuartoPaso']),
            review_gtm(){
                var products = [{
                       'name': this.auto.modelo,
                       'id': this.auto.id,
                       'brand': this.auto.marca,
                       'category': this.auto.categoria.categoria,
                                                    // Category/Category2/Category3 
                       'list': 'Vehículos | Selecciona el tipo de vehículos', 
                       'index': this.auto.categoria.orden,
                       'price': this.calculo.detalle.tarifa,
                       'coupon': '',
                        //Custom dimensions at product level
                       'extras': this.covers.EDD.nombre+', '+this.covers.CLP.nombre+', '+this.covers.CAP.nombre+', '+this.covers.RAP.nombre+', '+this.accesorios.sillabb.nombre+', '+this.accesorios.mifi.nombre, //CD16
                       'prepay_price': '',                                 //CM2
                       'pay_destination': '',                               //CM03
                        //Reserve. Custom dimensions at product level
                            'pick_up_location': this.calculo.reserva.nombre_ciudad_ret,//CD04 
                            'drop_off_location':this.calculo.reserva.nombre_ciudad_dev,//CD05  
                            'pick_up_date' : this.calculo.reserva.fecha_ret,            //CD06 
                            'pick_up_time' : this.calculo.reserva.hora_ret,                              //CD07           
                            'drop_off_date' : this.calculo.reserva.fecha_dev,           //CD08
                            'drop_off_time' : this.calculo.reserva.hora_dev,                             //CD09
                            'confirmation_number': '',                       //CD10                       
                            'transmission_type': this.auto.transmision,                           //CD12
                            'payment type': '',                             //CD13
                            'age': this.data.edad,                                             //CD14
                            'promotional_code': '',                       //CD18     
                            'number_of_passengers':  this.auto.capacidad,                   //CD19      
                            'codigo_vehiculo':  this.auto.titulo_vehiculo,               //CD20     
                            'booking_days': this.calculo.reserva.cant_dias,                                     //CM01
                            'airport_fee': this.calculo.detalle.apo_fee,                                //CM04 
                            'base_rate': this.calculo.detalle.porcentaje_apo_fee,                                  //CM05
                            'vehicle_license_fee': '',                        //CM06 -
                        }
                ];

                var obj2=[];
                var obj3=[];
                var obj = this.data.coberturas
                var obj_1 = this.data.accesorios
          
                var obj2 = obj.map((obj,i,a )=> ({
                      name: obj.nombre,
                      id: obj.sigla,
                      list_id: obj.sigla,
                      list_name: 'covers' ,
                      index: i,
                      price: obj.monto,
                      quantity: '1'
                }))

                var obj3 = obj_1.map((obj_1,i,a )=> ({
                      name: obj_1.nombre,
                      id: obj_1.sigla,
                      list_id: obj_1.sigla,
                      list_name: 'accesories' ,
                      index: i,
                      price: obj_1.monto,
                      quantity: '1'
                }))

                Array.prototype.push.apply(products, obj2);
                Array.prototype.push.apply(products, obj3);
      
                //console.log('view test', products)
  
                let gtm = useGtm();
              
                gtm.trackEvent({
                  'event': 'checkout',
                  'category' : 'ecommerce',             //Static data
                  'action' : 'review and reserve',      // Static data
                  
                   //Enhanced Ecommerce - UA
                  'ecommerce': {
                    'currencyCode': 'USD',
                    'checkout':{ 
                          'actionField': {
                            'step': 5, 
                            'option': 'review and reserve',},
                           },
                    'products': products,
                       },
                });
            },

                
        },
    }
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.modaltitle{
    color: white;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
   text-transform: uppercase;
}
.card{
    border: 1px solid #c3c3c3;
    border-radius: 0px;
    padding: 20px 31px 18px 17px;
    background-color: #f3f3f3;
}
.card2{
    border: 1px solid #c3c3c3;
    border-radius: 0px;
    padding: 41px 31px 18px 31px;
    background-color: #ffffff;
}
.card-header {
    padding: 0px;
    margin-bottom: 0;
    background-color: rgba(255, 255, 255, 0.03);
    border-bottom: 2px solid rgb(0, 0, 0);
}
.titledetails {
    font-weight: 600;
    font-style: normal;
    font-size: 1.625rem;
    text-transform: none;
    margin-bottom: 1.375rem;
    line-height: 20px;   
}
.modificar{
    text-align: right;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 900;
}
.btnModificar{
    color: #169a5a;
    cursor: pointer;
}
h3{
    font-weight: 700;
    font-style: normal;
    text-transform: uppercase;
    font-size: .875rem;
    color: inherit;
}
span {
    font-weight: 200;
    font-style: normal;
    font-size: 14px;
    //margin-bottom: .25rem;
    //display: block;
    max-width: 79%;
}
.spanXtras{
    margin-bottom: .25rem;
    display: block;
}
.form-control{
    border-radius: 0px;
}
.btnConfirm{
    
    font-weight: 700;
    font-style: normal;
    display: inline-block;
    padding: 0.5em 1em;
    border: 0;
    margin: 0;
    min-height: auto;
    background: #169a5a;
    color: white;
    line-height: inherit;
    letter-spacing: .0675rem;
    font-size: .875rem;
    text-align: center;
    text-transform: uppercase;

}
.btnNoConfirm{
    
    font-weight: 700;
    font-style: normal;
    display: inline-block;
    padding: 0.5em 1em;
    border: 0;
    margin: 0;
    min-height: auto;
    background: #616161;
    color: rgb(255, 255, 255);
    line-height: inherit;
    letter-spacing: .0675rem;
    font-size: .875rem;
    text-align: center;
    text-transform: uppercase;
    cursor: not-allowed;

}
.valor{
    font-size: 25px;
    padding: 23px 23px 0px;
}
.img-categoria{
    width: 122px;
    float:right;
}
.icon-transmission{
    background-image: url('/img/transmission_type.svg');
    background-size: 100%;
    background-repeat: no-repeat;
}
.ic{
    display: inline-block;
    width: 17px;
    height: 16px;
}

</style>